import { Component, input, output } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { MatIconButton } from "@angular/material/button";
import { MatDivider } from "@angular/material/divider";
import { TranslocoPipe } from "@jsverse/transloco";

@Component({
  selector: "app-layer-header",
  templateUrl: "./layer-header.component.html",
  styleUrl: "./layer-header.component.scss",
  imports: [MatIcon, MatIconButton, MatDivider, TranslocoPipe]
})
export class LayerHeaderComponent {
  minimizeModule = output<void>();

  closeModule = output<void>();

  canExpandPanel = input(true);

  canMinimize = input(true);
}
